import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  documentKey: {
    document_id: '',
    study_id: ''
  }
};

export const preferences = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    clearPreferences: state => {
      state.documentKey = {
        document_id: '',
        study_id: ''
      };
    },
    setDocumentKey: (state, action: PayloadAction<any>) => {
      state.documentKey = action.payload;
    }
  }
});

export const { clearPreferences, setDocumentKey } = preferences.actions;
